import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

const KIND_DOTS = { success: "#4a6b53", warning: "#d9a05b", info: "#4a7a8c" };
const dot = (k) => KIND_DOTS[k] || KIND_DOTS.info;

export default function NotificationsPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <header>
        <div className="overline">Signals</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight">
          Notifications
        </h1>
        <p className="mt-2 text-sm text-[#575752]">
          {items.length} announcements and updates.
        </p>
      </header>

      <div className="overflow-hidden rounded-lg border border-[#e5e5e0] bg-white">
        <ul className="divide-y divide-[#efefe9]">
          {items.map((n) => (
            <li key={n.id} className="flex gap-4 p-5" data-testid={`notification-${n.id}`}>
              <div
                className="mt-1 flex h-8 w-8 flex-none items-center justify-center rounded-full"
                style={{ backgroundColor: `${dot(n.kind)}20` }}
              >
                <Bell strokeWidth={1.5} className="h-4 w-4" style={{ color: dot(n.kind) }} />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-3">
                  <div className="font-display text-base font-bold">{n.title}</div>
                  <div className="font-mono text-[11px] text-[#8a8a80]">
                    {new Date(n.created_at).toLocaleString()}
                  </div>
                </div>
                <p className="mt-1 text-sm text-[#575752]">{n.body}</p>
              </div>
            </li>
          ))}
          {items.length === 0 && (
            <li className="p-10 text-center text-sm text-[#575752]">Inbox is empty.</li>
          )}
        </ul>
      </div>
    </div>
  );
}
